import React from "react";
import { graphql, Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

import Seo from '../components/seo/seo';
import Layout from '../components/layout/layout';
import Hero from "../components/hero/hero";
import SignUp from '../components/sign-up/sign-up';
import CollapsableList from '../components/collapsable-list/collapsable-list';
import PostSlider from '../components/post/slider';

import Timeline from '../components/b-corp/timeline';
import HeadlineResults from '../components/b-corp/headline-results';

const Page = ({ data, location }) =>  {
    const { wpPage, allWpPost } = data;
    const bCorpFields = wpPage?.template?.b_corp_fields;
    const bCorpPosts = allWpPost;

    return(
        <Layout location={ location }>
            <Hero
                heroSettings = { wpPage?.hero_settings }
                headingIsH1={ true }
            />

            <div className="body_layout">
                <div className="body_text body_text_center b-corp-intro">
                    <div dangerouslySetInnerHTML={{ __html: bCorpFields?.bCorpIntro }}></div>
                </div>
            </div>

            <HeadlineResults bCorpFields={ bCorpFields } />

            { bCorpFields.bCorpFullWidthImage &&
                <GatsbyImage draggable={ false } className="lazyload b-corp-headline-result-full-width-image" image={ bCorpFields?.bCorpFullWidthImage?.localFile?.childImageSharp?.gatsbyImageData } alt="" />
            }

            <div className="post-wrapper-bottom b-corp-post-slider" id="similar_posts_section">
                <div className="bkgd">
                <h2 className="h-large h-faded" dangerouslySetInnerHTML={{__html: bCorpFields?.bCorpNewsTitle}}></h2>
                </div>
                <PostSlider overflow={ false } posts={ bCorpPosts } useClientName={ false } type="blog" />
            </div>

            <Timeline bCorpFields={ bCorpFields } />


            { bCorpFields.bCorpPdfRepeater ?
        
                <div className="b-corp-pdf-wrapper">
                    <div className="body_layout">
                        <h2 className="h-large h-faded" dangerouslySetInnerHTML={{__html: bCorpFields?.bCorpPoliciesTitle}}></h2>
                    </div>
                    <CollapsableList
                        truncateAfter = { 3 }
                        wrapperClass = "b-corp-pdf-card-wrapper"
                    >
                        {
                            bCorpFields.bCorpPdfRepeater && bCorpFields.bCorpPdfRepeater.map((singlePdf, index) => {
                                return(
                                    <div key={`${singlePdf?.bCorpPdfRepeaterTitle}-${index}`} className="b-corp-pdf-card">
                                        <Link 
                                            to={ singlePdf?.bCorpPdfRepeaterPdfFile?.mediaItemUrl }
                                            target="_blank"
                                        >
                                            <p className="b-corp-pdf-card-title">{ singlePdf?.bCorpPdfRepeaterTitle }</p>
                                            <p className="b-corp-pdf-card-content">{ singlePdf?.bCorpPdfRepeaterContent }</p>
                                        </Link>
                                    </div>
                                )
                            })
                        }
                    </CollapsableList>
                </div>

            :null}

            <SignUp />
        </Layout>
    )
}

export const Head = ({ location, params, data, pageContext }) => {
    const { wpPage } = data;
    const { seo } = wpPage;
    return <Seo seo={seo} pageContext={pageContext} />
};

export const query = graphql`
    query ($id: String) {
        allWpPost(limit: 3, filter: {tags: {nodes: {elemMatch: {name: {eq: "b-corp"}}}}, status: {eq: "publish"}}) {
            edges {
                node {
                    id
                    slug
                    link
                    date
                    excerpt
                    title
                    primaryService
                    primaryServiceTitle
                    servicesTaxonomy {
                    nodes {
                        databaseId
                        id
                        name
                        slug
                    }
                    }
                    featuredImage {
                    node {
                        localFile {
                        childImageSharp {
                            gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
                        }
                        }
                    }
                    }
                }
            }
        }
        wpPage(id: {eq: $id}) {
            title
            content
            seo {
            fullHead
            title
            }
            ...heroBlockFields
            template {
                ... on WpTemplate_BCorp {
                  templateName
                  b_corp_fields {
                    bCorpIntro
                    bCorpFullWidthImage {
                        localFile {
                          childImageSharp {
                            gatsbyImageData
                          }
                        }
                    }
                    bCorpHeadlineResultsRepeater {
                        bCorpHeadlineResultsRepeaterStat
                        bCorpHeadlineResultsRepeaterTitle
                    }
                    bCorpPdfRepeater {
                        bCorpPdfRepeaterContent
                        bCorpPdfRepeaterTitle
                        bCorpPdfRepeaterPdfFile {
                          mediaItemUrl
                        }
                    }
                    bCorpJourneyRepeater {
                        bCorpJourneyRepeaterContent
                        bCorpJourneyRepeaterDate
                        bCorpJourneyRepeaterImage {
                            localFile {
                                childImageSharp {
                                    gatsbyImageData
                                }
                            }
                        }
                    }
                    bCorpPending
                    bCorpNewsTitle
                    bCorpPoliciesTitle
                  }
                }
            }
        }
    }
`

export default Page;